import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';
import { authHeader } from '../utils/authHeaders';

// Async thunk for fetching organization color by user email
export const fetchOrganizationColor = createAsyncThunk(
  'theme/fetchOrganizationColor',
  async (userEmail) => {
    try {
      const response = await axios.get(`${BASE_URL}/organizations/user/${userEmail}`, {
        headers: { ...authHeader() },
      });
      return response.data.organization || { primary_color: '#5F6368' };
    } catch (error) {
      console.error('Failed to fetch organization color:', error);
      return { primary_color: '#5F6368' }; // Default fallback
    }
  }
);

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    primaryColor: '#5F6368', // Default color
    organization: null,
    loading: false,
    error: null,
  },
  reducers: {
    setPrimaryColor: (state, action) => {
      state.primaryColor = action.payload;
    },
    resetTheme: (state) => {
      state.primaryColor = '#5F6368';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationColor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganizationColor.fulfilled, (state, action) => {
        state.loading = false;
        state.primaryColor = action.payload.primary_color || '#5F6368';
        state.organization = action.payload;
      })
      .addCase(fetchOrganizationColor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.primaryColor = '#5F6368'; // Fallback to default
      });
  },
});

export const { setPrimaryColor, resetTheme } = themeSlice.actions;
export default themeSlice.reducer; 